import './polyfills/polyfills.js'
import start from './start.js'
import dev from '#dev/js/dev.js'

export default async contracts => start({ ...contracts, dev })
